/* ============================================================
   ELVA SCROLL REVEAL
   ------------------------------------------------------------
   This is the missing piece that made the theme feel "flatter"
   than elva-homepage.html / elva-product.html / elva-about.html /
   elva-contact.html / elva-faq.html / elva-manifesto.html /
   elva-sizeguide.html.

   Those HTML files all load a shared script (elva-shared.js)
   whose initReveal() fades + slides sections and cards into
   view as you scroll. That file was never ported when the
   theme was built, so every section here has always rendered
   "on" instantly with no entrance animation.

   This is that same system, rebuilt to target the class names
   actually used in this theme today (many were renamed during
   the Shopify build — e.g. .story -> .ab-story, .mission ->
   .ab-mission — this file targets the current names directly).

   Respects prefers-reduced-motion. Elements inside fixed/sticky
   containers (cart drawer, sticky header) are skipped, same as
   the original.

   NOTE: will-change is released once each element's reveal
   transition finishes. Leaving will-change set indefinitely
   keeps the element on its own compositor layer, which can
   cause content added inside it later (e.g. an accordion
   answer toggled open after the reveal has long finished) to
   fail to repaint correctly until something forces a reflow.
   ============================================================ */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function isFixed(el) {
    var node = el;
    while (node && node !== document.body) {
      var pos = window.getComputedStyle(node).position;
      if (pos === 'fixed' || pos === 'sticky') return true;
      node = node.parentElement;
    }
    return false;
  }

  // ── Whole sections: fade up as one block ──
  var sectionSelectors = [
    // Homepage
    '.about-blurb', '.split-section', '.collections-section', '.releases-section',
    '.category-section', '.community-section', '.press-section', '.social-section',
    // Product page
    '.feature-highlight', '.rfy-section', '.reviews-section',
    // About page
    '.ab-mission', '.ab-stats', '.ab-story', '.ab-sustain', '.ab-cta', '.ab-process',
    // Contact page
    '.contact-methods-strip', '.contact-main-wrap',
    // FAQ page
    '.faq-wrap',
    // Manifesto page
    '.for-against', '.enemy-section', '.manifesto-cta', '.manifesto-section',
    // Size guide page
    '.sg-measure'
  ];

  // ── Cards that stagger in inside their section ──
  var cardSelectors = [
    '.collection-card', '.category-card', '.ab-value-card', '.ab-process__step',
    '.contact-method-card', '.contact-info-card', '.pillar', '.who-trait',
    '.faq-category', '.rev-card', '.feat', '.ab-stat', '.social-tile',
    '.sg-size-section', '.sg-fit-card'
  ];

  var els = [];

  sectionSelectors.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (isFixed(el) || el._elvaReveal) return;
      els.push({ el: el, dx: 0, dy: 40, delay: 0 });
    });
  });

  cardSelectors.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el, i) {
      if (isFixed(el) || el._elvaReveal) return;
      els.push({ el: el, dx: 0, dy: 30, delay: Math.min(i % 5, 4) * 80 });
    });
  });

  // ── Left / right pairs ──
  document.querySelectorAll('.ab-story__imgs, .fh-image').forEach(function (el) {
    if (!isFixed(el) && !el._elvaReveal) els.push({ el: el, dx: -40, dy: 0, delay: 0 });
  });
  document.querySelectorAll('.ab-story__text, .fh-content').forEach(function (el) {
    if (!isFixed(el) && !el._elvaReveal) els.push({ el: el, dx: 40, dy: 0, delay: 0 });
  });

  // ── Apply hidden state ──
  els.forEach(function (item) {
    var el = item.el;
    el._elvaReveal = true;
    el._elvaVisible = false;
    el.style.opacity = '0';
    el.style.transform = 'translate(' + item.dx + 'px,' + item.dy + 'px)';
    el.style.transition = 'opacity 0.75s ease ' + item.delay + 'ms, transform 0.75s ease ' + item.delay + 'ms';
    el.style.willChange = 'opacity, transform';
  });

  function releaseWillChange(el) {
    el.style.willChange = 'auto';
    el.style.removeProperty('will-change');
  }

  function show(el, delay) {
    if (el._elvaVisible) return;
    el._elvaVisible = true;
    el.style.opacity = '1';
    el.style.transform = 'translate(0,0)';

    var cleaned = false;
    function cleanup() {
      if (cleaned) return;
      cleaned = true;
      el.removeEventListener('transitionend', onTransitionEnd);
      releaseWillChange(el);
      // Force a repaint on this element's subtree so any content
      // that changes display later (e.g. an accordion opening)
      // starts from a clean, uncomposited paint state.
      void el.offsetHeight;
    }
    function onTransitionEnd(e) {
      if (e.target === el && (e.propertyName === 'opacity' || e.propertyName === 'transform')) {
        cleanup();
      }
    }
    el.addEventListener('transitionend', onTransitionEnd);
    // Fallback in case transitionend never fires (delay + duration + margin)
    setTimeout(cleanup, (delay || 0) + 900);
  }

  // Reveal anything already in the viewport (avoids a flash of
  // hidden content just below the hero on page load)
  els.forEach(function (item) {
    var r = item.el.getBoundingClientRect();
    if (r.top < window.innerHeight - 40 && r.bottom > 0) show(item.el, item.delay);
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var match = els.filter(function (item) { return item.el === entry.target; })[0];
        show(entry.target, match ? match.delay : 0);
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  els.forEach(function (item) {
    if (!item.el._elvaVisible) io.observe(item.el);
  });
})();
